export const content = `
<p>Alegerea unei firme de curățenie nu înseamnă doar „cineva care dă cu aspiratorul”. Înseamnă un parteneriat care îți protejează investiția în imobil și sănătatea celor care îl ocupă. La Doral Cleaning, am structurat serviciile noastre pe trei piloni principali.</p>

<div style="background-color: #f7f9fc; border-left: 4px solid #1a73e8; padding: 1.5rem; margin: 2rem 0; border-radius: 0 8px 8px 0;">
  <p style="font-weight: 700; margin-bottom: 0.8rem; color: #1d2a3a;">TL;DR — Rezumat rapid:</p>
  <ul style="list-style-type: none; padding-left: 0; margin-bottom: 0; line-height: 1.8;">
    <li><strong>Versatilitate:</strong> O firmă profesionistă acoperă de la locuințe private (vile/apartamente) până la complexe industriale mari.</li>
    <li><strong>Echipamente:</strong> Utilizarea de utilaje industriale și soluții ecologice, imposibil de replicat cu unelte casnice.</li>
    <li><strong>Eficiență:</strong> Economisești timp și resursă umană, beneficiind de standarde de igienă certificate.</li>
    <li><strong>Personalizare:</strong> Serviciile sunt adaptate după fluxul de lucru al clientului.</li>
  </ul>
</div>

<div style="background-color: #f7f9fc; border-left: 4px solid #1a73e8; padding: 1.5rem; margin: 2rem 0; border-radius: 0 8px 8px 0;">
  <p style="font-weight: 700; margin-bottom: 0.8rem; color: #1d2a3a;">Cuprins articol:</p>
  <ul style="list-style-type: none; padding-left: 0; margin-bottom: 0; line-height: 1.8;">
    <li><a href="#rezidential" style="color: #1a73e8; text-decoration: none; font-weight: 600;">1. Curățenie pentru Vile și Apartamente (Rezidențial)</a></li>
    <li><a href="#corporate" style="color: #1a73e8; text-decoration: none; font-weight: 600;">2. Curățenie Corporate și Spații Comerciale</a></li>
    <li><a href="#industrial" style="color: #1a73e8; text-decoration: none; font-weight: 600;">3. Soluții pentru Hale, Fabrici și Depozite (Industrial)</a></li>
    <li><a href="#comparatie" style="color: #1a73e8; text-decoration: none; font-weight: 600;">4. Compararea tipurilor de servicii</a></li>
    <li><a href="#studiu-de-caz" style="color: #1a73e8; text-decoration: none; font-weight: 600;">5. Studiu de caz: De ce merită externalizarea?</a></li>
    <li><a href="#faq" style="color: #1a73e8; text-decoration: none; font-weight: 600;">6. Întrebări frecvente (FAQ)</a></li>
  </ul>
</div>

<h2 id="rezidential">1. Curățenie pentru Vile și Apartamente (Rezidențial)</h2>
<p>Locuința este spațiul tău cel mai personal. O firmă de curățenie aduce în mediul rezidențial un nivel de detaliu care depășește curățenia săptămânală obișnuită:</p>
<ul>
  <li><strong>Curățenie generală/de întreținere:</strong> Aspirare, spălare suprafețe, igienizare băi și bucătării.</li>
  <li><strong>Curățenie după constructor:</strong> Îndepărtarea urmelor de vopsea, ciment și praf fin. Vezi și detalii despre serviciul de <a href="/curatenie-post-construct/">curățenie post constructor</a>.</li>
  <li><strong>Servicii speciale:</strong> Curățarea canapelelor și a mochetelor cu injecție-extracție. Vezi serviciul dedicat de <a href="/curatare-mochete/">curățare mochete</a>.</li>
</ul>

<h2 id="corporate">2. Curățenie Corporate și Spații Comerciale</h2>
<p>Imaginea unei afaceri începe de la curățenia din recepție. Mediul de lucru influențează direct productivitatea angajaților tăi:</p>
<ul>
  <li><strong>Întreținere zilnică:</strong> Menținerea curățeniei în birouri și săli de conferință. Află mai multe despre <a href="/curatenie-de-intretinere/">curățenia de întreținere</a> și pachetele noastre dedicate de <a href="/curatenie-birouri-firme-spatii-comerciale/">curățenie pentru birouri și spații comerciale</a>.</li>
  <li><strong>Igienizare spații sanitare:</strong> Aprovizionarea cu consumabile și dezinfecție.</li>
  <li><strong>Spații comerciale:</strong> Tratament special pentru pardoseli cu trafic intens.</li>
</ul>

<h2 id="industrial">3. Soluții pentru Hale, Fabrici și Depozite (Industrial)</h2>
<p>Curățenia industrială necesită rigoare și echipamente grele. Aici, miza nu este doar estetica, ci și siguranța muncii:</p>
<ul>
  <li><strong>Curățarea pardoselilor industriale:</strong> Utilizarea mașinilor automate de spălat. Detalii complete pe pagina de <a href="/curatare-pardoseli/">curățare pardoseli</a> și soluții extinse de <a href="/curatenie-fabrici-depozite-hale/">curățenie în hale și depozite</a>.</li>
  <li><strong>Degresare și decapare:</strong> Curățarea structurilor metalice și a conductelor.</li>
  <li><strong>Managementul deșeurilor:</strong> Soluții pentru colectarea și evacuarea resturilor specifice.</li>
</ul>

<h2 id="comparatie">4. Compararea tipurilor de servicii</h2>
<div style="overflow-x: auto; margin: 2rem 0;">
  <table style="width: 100%; border-collapse: collapse; text-align: left; font-size: 0.95rem;">
    <thead>
      <tr style="background-color: #f1f5f9; border-bottom: 2px solid #cbd5e1;">
        <th style="padding: 12px; font-weight: 700;">Caracteristică</th>
        <th style="padding: 12px; font-weight: 700;">Rezidențial</th>
        <th style="padding: 12px; font-weight: 700;">Corporate</th>
        <th style="padding: 12px; font-weight: 700;">Industrial</th>
      </tr>
    </thead>
    <tbody>
      <tr style="border-bottom: 1px solid #e2e8f0;">
        <td style="padding: 12px; font-weight: 600;">Frecvență</td>
        <td style="padding: 12px;">Ocazional</td>
        <td style="padding: 12px;">Zilnic</td>
        <td style="padding: 12px;">Planificat</td>
      </tr>
      <tr style="border-bottom: 1px solid #e2e8f0;">
        <td style="padding: 12px; font-weight: 600;">Echipamente</td>
        <td style="padding: 12px;">Aspiratoare, abur</td>
        <td style="padding: 12px;">Monodiscuri</td>
        <td style="padding: 12px;">Mașini om-la-bord</td>
      </tr>
      <tr style="border-bottom: 1px solid #e2e8f0;">
        <td style="padding: 12px; font-weight: 600;">Focus</td>
        <td style="padding: 12px;">Confort</td>
        <td style="padding: 12px;">Imagine</td>
        <td style="padding: 12px;">Siguranță</td>
      </tr>
    </tbody>
  </table>
</div>

<h2 id="studiu-de-caz">5. Studiu de caz: De ce merită externalizarea?</h2>
<p><strong>Exemplu:</strong> O hală de 2.000 mp.</p>
<ul>
  <li><strong>Fără firmă:</strong> Angajarea personalului propriu implică salarii, taxe, concedii și achiziție utilaje (aprox. 5.000€).</li>
  <li><strong>Cu Doral Cleaning:</strong> Plătești un serviciu complet. Utilajele noastre curăță suprafața în 4 ore, în loc de 2 zile, iar rezultatul este uniform și conform normelor.</li>
</ul>

<h2 id="faq">6. Întrebări frecvente (FAQ)</h2>
<p><strong>Ce include curățenia post-constructor?</strong><br/>
Include îndepărtarea urmelor de var, silicon, aspirarea industrială a praului și curățarea geamurilor de etichete.</p>

<div style="background: linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%); border-radius: 12px; padding: 2rem; margin: 2.5rem 0; text-align: center; color: #fff;">
  <p style="font-size: 1.15rem; font-weight: 600; margin-bottom: 0.5rem;">Cere o ofertă personalizată!</p>
  <p style="margin-bottom: 1.2rem; opacity: 0.92;">Fie că ai nevoie de servicii profesionale pentru birou, fabrică sau locuință, echipa Doral Cleaning este pregătită cu soluții complete.</p>
  <a href="/contact-curatenie/" style="background:#fff; color:#1a73e8; font-weight:700; padding:0.65rem 1.75rem; border-radius:8px; text-decoration:none; display:inline-block;">Contactează-ne</a>
</div>
`;

export const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Ce servicii ofera o firma de curatenie profesionala?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "O firma profesionala ofera servicii rezidentiale, corporate si industriale."
      }
    },
    {
      "@type": "Question",
      "name": "Ce include curățenia post-constructor?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Include îndepărtarea urmelor de var, silicon, aspirarea industrială a prafului și curățarea geamurilor de etichete."
      }
    }
  ]
};
